/* cart-drawer.js · la bolsa en un panel (home v7.1, bloque C; store-v9-1 S6).
   Marcado, reglas y por qué las líneas no se pintan tal cual llegan de
   /cart.js: `snippets/cart-drawer.liquid`.

   · Lo abre el enlace «Bag N» del header (`[data-cart-open]`). Sin JS, o
     con una tecla modificadora (nueva pestaña), el enlace va a /cart.
   · Regla 1: con `checkout_open` apagado (`data-checkout` ≠ "true") no se
     abre nunca: el enlace no se engancha y va a /cart, y `open()` no hace
     nada (fix/bag-closed-sitewide, 27 oct 2026).
   · Al abrir: pinta lo que el servidor escribió (el mapa) y vuelve a pedir
     /cart.js; con la respuesta rehace las líneas, el subtotal y los dos
     contadores (el del panel y el del header).
   · Cantidad: «−» y «+» de cada línea van por /cart/change.js (a 0, la
     línea sale); el panel se rehace con el carrito que devuelve.
   · Regalo y nota: el pie es un formulario a /cart con `checkout`; al
     enviarlo, si la casilla está marcada la nota empieza por «Gift: no
     prices on the slip».
   · Cierra con Esc, con el velo y con «Close». El foco entra en el panel, no
     sale de él con Tab y vuelve al enlace al cerrar. `aria-modal`.
   · Entra y sale con el efecto 6 de motion v2 (`docs/motion.md`) por
     `acaciasupplies.motion.open/close`; con movimiento reducido, en seco.
     Con el panel abierto el fondo no se desplaza (`lock`/`unlock`).
   · `add(variante, cantidad, botón, datos)` (efecto 5): añade al carrito,
     rehace las líneas con /cart.js, el botón pasa a «Added» y el panel entra
     con la línea nueva YA dentro. Lo llama la ficha (`product-object.js`)
     con `datos` = lo que se puede enseñar de esa línea ({ maker, name,
     variant, image, price, preorder }), con la misma puerta de la regla 2.
   · Si /cart.js falla, el panel se queda con lo que tenía, lo marca con
     `data-cart-stale` y el error se registra en la consola: no se descarta
     (regla 12). */
(function (d, w) {
  var root = d.querySelector('[data-cart-drawer]');
  if (!root || !w.fetch) return;

  var selling = root.getAttribute('data-checkout') === 'true';
  var panel = root.querySelector('[role="dialog"]');
  var list = root.querySelector('[data-cart-lines]');
  var empty = root.querySelector('[data-cart-empty]');
  var foot = root.querySelector('[data-cart-foot]');
  var subtotal = root.querySelector('[data-cart-subtotal]');
  var tpl = root.querySelector('template[data-cart-line]');
  var counts = function () { return d.querySelectorAll('[data-cart-count]'); };
  /* Lo que el servidor deja enseñar de cada línea (ver el snippet). */
  var map = {};
  var known = root.querySelector('template[data-cart-known]');
  if (known) {
    known.content.querySelectorAll('[data-variant]').forEach(function (el) {
      map[el.dataset.variant] = {
        key: el.dataset.key, maker: el.dataset.maker, name: el.dataset.name, variant: el.dataset.vtitle,
        image: el.dataset.image, preorder: el.dataset.pre, price: el.dataset.price, quantity: +el.dataset.quantity || 0
      };
    });
  }

  var html = d.documentElement;
  var savedY = 0;
  function lock() {
    savedY = w.scrollY;
    html.style.setProperty('--as-cart-gutter', (w.innerWidth - html.clientWidth) + 'px');
    html.classList.add('is-cart-locked');
  }
  function unlock() {
    html.classList.remove('is-cart-locked');
    html.style.removeProperty('--as-cart-gutter');
    w.scrollTo({ top: savedY, left: 0, behavior: 'instant' });
  }

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var opener = null;

  /* El precio del servidor llega con las entidades de `unit` como texto. */
  function chars(s) {
    return String(s || '').replace(/&#(\d+);/g, function (_, n) { return String.fromCharCode(+n); });
  }
  function euros(c) {
    c = +c || 0;
    var r = c % 100;
    return c > 0 ? ((c - r) / 100) + (r ? '.' + ('0' + r).slice(-2) : '') + ' €' : '';
  }

  /* El contrato del contador (lote v10 A, el mismo que `v10-card.js`): en
     todo `[data-cart-count]`, el número solo. También el 0: «Bag (0)»
     (decisión de Eric, 27 oct 2026; lote pdp-datos S3). Antes, nada con 0. */
  function setCount(n) {
    counts().forEach(function (el) {
      el.textContent = String(n > 0 ? n : 0);
    });
  }

  /* Una línea de /cart.js → una fila. De /cart.js: variante, clave,
     cantidad y precio; lo que se enseña del producto, del mapa. */
  function row(item) {
    var safe = map[String(item.variant_id)] || {};
    var li = tpl.content.firstElementChild.cloneNode(true);
    if (safe.image) {
      var img = d.createElement('img');
      img.className = 'cart-line__img';
      img.alt = '';
      img.width = 64;
      img.height = 85;
      img.loading = 'lazy';
      img.decoding = 'async';
      img.src = safe.image;
      li.querySelector('.cart-line__media').appendChild(img);
    }
    var name = safe.name || '';
    li.querySelector('.cart-line__maker').textContent = safe.maker || '';
    li.querySelector('.cart-line__name').textContent = name;
    li.querySelector('.cart-line__variant').textContent = safe.variant || '';
    li.querySelector('.cart-line__pre').textContent = safe.preorder || '';
    li.querySelector('.cart-line__n').textContent = String(item.quantity);
    var price = item.final_line_price != null ? euros(item.final_line_price) : chars(safe.price);
    li.querySelector('.cart-line__price').textContent = price;
    var key = item.key || safe.key || String(item.variant_id);
    li.querySelectorAll('[data-cart-step]').forEach(function (b) {
      var step = +b.getAttribute('data-cart-step');
      b.setAttribute('aria-label', (step < 0 ? 'One less' : 'One more') + (name ? ' ' + name : ''));
      b.addEventListener('click', function () { change(key, Math.max(0, item.quantity + step), b); });
    });
    return li;
  }

  function paint(items, count, total) {
    painted = true;
    list.replaceChildren.apply(list, items.map(row));
    empty.hidden = count > 0;
    if (foot) foot.hidden = count === 0;
    if (subtotal && total != null) subtotal.textContent = euros(total);
    setCount(count);
  }

  function take(cart) {
    root.removeAttribute('data-cart-stale');
    paint(cart.items || [], cart.item_count || 0, cart.total_price);
  }

  function refresh() {
    return w.fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('/cart.js ' + r.status);
        return r.json();
      })
      .then(take)
      .catch(function (err) {
        root.setAttribute('data-cart-stale', '');
        console.error('cart-drawer: could not refresh from /cart.js', err);
      });
  }

  function change(key, quantity, button) {
    if (button) button.disabled = true;
    return w.fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('/cart/change.js ' + r.status);
        return r.json();
      })
      .then(function (cart) {
        take(cart);
        var close_ = root.querySelector('.cart-drawer__close');
        if (button && !button.isConnected && close_) close_.focus({ preventScroll: true });
      })
      .catch(function (err) {
        if (button) button.disabled = false;
        root.setAttribute('data-cart-stale', '');
        console.error('cart-drawer: could not change the quantity', err);
      });
  }

  function focusables() {
    return Array.prototype.filter.call(panel.querySelectorAll(FOCUSABLE), function (el) {
      return !el.hidden && el.getClientRects().length > 0;
    });
  }

  function onKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) { e.preventDefault(); panel.focus(); return; }
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (d.activeElement === first || d.activeElement === panel)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  var motion = function () { return (w.acaciasupplies && w.acaciasupplies.motion) || null; };
  var isOpen = false;

  function open(from, fresh) {
    if (!selling) return Promise.resolve();
    paintKnown();
    if (!isOpen) {
      isOpen = true;
      opener = from || d.activeElement;
      lock();
      if (motion()) motion().open(root);
      else root.hidden = false;
      if (opener && opener.setAttribute) opener.setAttribute('aria-expanded', 'true');
      d.addEventListener('keydown', onKey);
      var close_ = root.querySelector('.cart-drawer__close');
      (close_ || panel).focus({ preventScroll: true });
    }
    return fresh ? Promise.resolve() : refresh();
  }

  function close() {
    if (!isOpen) return Promise.resolve();
    isOpen = false;
    d.removeEventListener('keydown', onKey);
    if (opener && opener.setAttribute) opener.setAttribute('aria-expanded', 'false');
    var back = opener;
    opener = null;
    function done() {
      if (isOpen) return;
      unlock();
      if (back && back.focus) back.focus({ preventScroll: true });
    }
    if (!motion()) { root.hidden = true; done(); return Promise.resolve(); }
    return motion().close(root).then(done);
  }

  function add(variant, quantity, button, safe) {
    if (safe) map[String(variant)] = safe;
    if (button) button.disabled = true;
    return w.fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +variant, quantity: quantity || 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('/cart/add.js ' + r.status);
        return refresh();
      })
      .then(function () {
        if (button) {
          button.disabled = false;
          if (motion()) motion().respond(button, 'Added');
        }
        return open(button, true);
      })
      .catch(function (err) {
        if (button) button.disabled = false;
        console.error('cart-drawer: could not add to the bag', err);
        throw err;
      });
  }

  /* Lo que el servidor sabía al pintar la página, para no abrir en blanco. */
  var painted = false;
  function paintKnown() {
    if (painted) return;
    painted = true;
    var known_ = Object.keys(map).map(function (k) { return { variant_id: k, quantity: map[k].quantity, key: map[k].key }; });
    list.replaceChildren.apply(list, known_.map(row));
  }

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-close]')) close();
  });

  /* Regalo: la nota empieza por la línea del albarán (una vez). */
  if (foot) {
    foot.addEventListener('submit', function () {
      var gift = foot.querySelector('[data-cart-gift]');
      var note = foot.querySelector('[data-cart-note]');
      if (!note) return;
      var GIFT = 'Gift: no prices on the slip';
      var rest = note.value.replace(GIFT, '').replace(/^\s+/, '');
      note.value = gift && gift.checked ? GIFT + (rest ? '\n' + rest : '') : rest;
    });
  }

  if (selling) d.querySelectorAll('[data-cart-open]').forEach(function (a) {
    a.setAttribute('aria-controls', 'cart-drawer');
    a.setAttribute('aria-expanded', 'false');
    a.setAttribute('aria-haspopup', 'dialog');
    a.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault();
      open(a);
    });
  });

  w.acaciasupplies = w.acaciasupplies || {};
  w.acaciasupplies.cartDrawer = { open: open, close: close, refresh: refresh, add: add, change: change };
})(document, window);
